/**
 * ? Validation can be array of validation objects or an object
 * ? Validation object has field:
 * ? > col: start column index (will apply validation for all columns from this column)
 * ? > colName: start column name (will apply validation for all columns from this column)
 * ? > validate: function
 * ? Note: only use col or colName
 */
import i18n from "../../lang/i18n";

const DATA_SHEET_VALIDATION = {
  col: "B",
  validate: function(cellValue) {
    if (isNaN(cellValue) || +cellValue < 0) {
      return i18n.t("validation.required_field");
    }

    return "";
  }
};

const CATEGORIES_SHEET_VALIDATION = [
  {
    col: "C",
    validate: function(cellValue) {
      if (isNaN(cellValue) || +cellValue < 0) {
        return i18n.t("validation.required_field");
      }

      return "";
    }
  }
];

const SRI_SMI_SHEET_VALIDATION = [
  {
    col: "A",
    validate: function(cellValue) {
      if (!cellValue) {
        return i18n.t("validation.required_field");
      }
      return "";
    }
  },
  {
    col: "B",
    validate: function(cellValue) {
      if (!cellValue || !/^([1-9]|1[012])$/.test(cellValue)) {
        return i18n.t(
          "validation.the_grade_must_only_have_digits_from_1_to_12"
        );
      }

      return "";
    }
  },
  {
    col: "D",
    validate: function(cellValue) {
      if (!cellValue || !/^[0-9]*$/.test(cellValue)) {
        return i18n.t("validation.the_grade_must_only_have_digits");
      }

      return "";
    }
  },
  {
    colName: "SRI LAST LEXILE SCORE",
    validate: function(cellValue) {
      if (!cellValue || !/^[0-9]*$/.test(cellValue)) {
        return i18n.t("validation.the_grade_must_only_have_digits");
      }

      return "";
    }
  }
];

const ACT_SHEET_VALIDATION = [
  {
    col: "A",
    validate: function(cellValue) {
      if (!cellValue) {
        return i18n.t("validation.required_field");
      }
      return "";
    }
  },
  {
    colName: "Test date",
    validate: function(cellValue) {
      if (!cellValue) {
        return i18n.t("validation.required_field");
      }
      return "";
    }
  }
];

const SBAC_SHEET_VALIDATION = [
  {
    col: "A",
    validate: function(cellValue) {
      if (!cellValue) {
        return i18n.t("validation.required_field");
      }
      return "";
    }
  },
  {
    colName: "Grade",
    validate: function(cellValue) {
      if (!cellValue) {
        return i18n.t("validation.required_field");
      }
      return "";
    }
  }
];

const IELTS_SHEET_VALIDATION = [
  {
    colName: "Student code",
    validate: function(cellValue) {
      if (!cellValue) {
        return i18n.t("validation.required_field");
      }
      return "";
    }
  },
  {
    colName: "Test name",
    validate: function(cellValue) {
      if (!cellValue) {
        return i18n.t("validation.required_field");
      }
      return "";
    }
  },
  {
    colName: "Test date S",
    validate: function(cellValue) {
      if (!cellValue) {
        return i18n.t("validation.required_field");
      }
      return "";
    }
  },
  {
    colName: "Test date W",
    validate: function(cellValue) {
      if (!cellValue) {
        return i18n.t("validation.required_field");
      }
      return "";
    }
  }
];
const SAT_SHEET_VALIDATION = [
  {
    colName: "Student code",
    validate: function(cellValue) {
      if (!cellValue) {
        return i18n.t("validation.required_field");
      }
      return "";
    }
  },
  {
    colName: "Test date",
    validate: function(cellValue) {
      if (!cellValue) {
        return i18n.t("validation.required_field");
      }
      return "";
    }
  },
  {
    colName: "Test name",
    validate: function(cellValue) {
      if (!cellValue) {
        return i18n.t("validation.required_field");
      }
      return "";
    }
  }
];

const DATA_ENROLL_STUDENT_SHEET_VALIDATION = [
  {
    col: "A",
    validate: function(cellValue) {
      if (!cellValue) {
        return i18n.t("validation.required_field");
      }
      return "";
    }
  }
];

export {
  DATA_SHEET_VALIDATION,
  SAT_SHEET_VALIDATION,
  CATEGORIES_SHEET_VALIDATION,
  SRI_SMI_SHEET_VALIDATION,
  ACT_SHEET_VALIDATION,
  SBAC_SHEET_VALIDATION,
  IELTS_SHEET_VALIDATION,
  DATA_ENROLL_STUDENT_SHEET_VALIDATION
};
